import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Form, Input, Label } from 'reactstrap';
import InputField from 'src/components/Input';
import { config } from 'src/config';
import { setFromErrors } from 'src/helpers';
import { useUpdateEducationalProfileMutation } from 'src/rtk/features/educational/educationalApi';
import { useGetLookupDataQuery } from 'src/rtk/features/setup/lookup/lookupDataApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import { useGetPersonalProfileQuery } from 'src/rtk/features/trainee/traineeApi';
import * as Yup from 'yup';
import loader from '../../../assets/images/loader.gif';

interface editInfoID {
  editInfoID: string;
  setIsAddForm: any;
}
const EditEducation = ({ editInfoID, setIsAddForm }: editInfoID) => {
  const initialValues: EducationalProfile = {
    id: '',
    name_of_the_degree: '',
    others_name_of_the_degree_value: '',
    institute_or_university: '',
    others_institute_or_university_value: '',
    passing_year: '',
    certificate_pdf: '',
    roll: '',
    session: '',
    subject: '',
    present_designation: '',
    present_working_place: '',
    // start_date: '',
    // end_date: '',
  };

  const FILE_SIZE = 1024 * 1024;
  const history = useHistory();

  const fileInputRef = useRef<any>();
  const instituteSearchableRef = useRef<any>();
  const [selectedYear, setSelectedYear] = useState<any>('');

  const { data: degreeLookupData } = useGetLookupDataQuery(
    'educational_qualification',
  );
  const [photo, setPhoto] = useState('');

  const { data: instituteLookupData } = useGetOrganizationsQuery();

  const { data: designationLookupData } = useGetLookupDataQuery('designation');

  const { data: sessionLookupData } = useGetLookupDataQuery('session');

  const { data: subjectLookupData } = useGetSubjectInfosQuery();

  const degreeList: Lookup[] = (degreeLookupData as any)?.data[0]?.childs || [];

  const instituteList: Organization[] =
    (instituteLookupData as any)?.data || [];

  const { data: educationalProfile } = useGetPersonalProfileQuery();

  const editEduInfoRecord =
    educationalProfile?.data?.details?.educational_infos?.find(
      (info) => info.id! === editInfoID,
    ) ?? ([] as EducationalProfile);

  const instituteOptions: SelectOption[] = [
    ...instituteList?.map((o: Organization) => ({
      label: o.organization_name!,
      value: o.organization_name!,
    })),
  ];

  if (
    !instituteOptions.find(
      (option: SelectOption) =>
        option.value === editEduInfoRecord.institute_or_university,
    )
  ) {
    instituteOptions.push({
      label: editEduInfoRecord.institute_or_university!,
      value: editEduInfoRecord.institute_or_university!,
    });
  }

  const designationList: Lookup[] =
    (designationLookupData as any)?.data[0]?.childs || [];

  const sessionList: Lookup[] =
    (sessionLookupData as any)?.data[0]?.childs || [];

  const subjectList: SubjectInfo[] = (subjectLookupData as any)?.data || [];

  const allSubjects: SelectOption[] =
    subjectLookupData?.data?.map((subject) => ({
      value: subject.subject_name,
      label: subject.subject_name,
    })) || [];

  const currentYear = new Date().getFullYear();
  const differenceOfTwoYear = currentYear - 1950;
  const startYear = currentYear - differenceOfTwoYear;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }

  const allYears: SelectOption[] = years?.map((item: any) => ({
    value: item,
    label: item,
  }));

  const [updateEducationalProfile, { isSuccess, isError, error, isLoading }] =
    useUpdateEducationalProfileMutation();

  const err: CustomError = error as CustomError;

  const {
    handleSubmit,
    getFieldProps,
    touched,
    errors,
    values,
    setValues,
    handleChange,
    setFieldValue,
    resetForm,
    setErrors,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      name_of_the_degree: Yup.string().required('Please Select a Degree'),
      institute_or_university: Yup.string().required('Institute is Required'),
      passing_year: Yup.string().required('Passsing Year is Required'),
      others_name_of_the_degree_value: Yup.string().when(
        'name_of_the_degree',
        (name_of_the_degree, schema) => {
          if (name_of_the_degree === 'Others') {
            return schema.required('Degree is Required!');
          }
          return schema;
        },
      ),
      others_institute_or_university_value: Yup.string().when(
        'institute_or_university',
        (institute_or_university, schema) => {
          if (institute_or_university === 'Others') {
            return schema.required('Institute is Required!');
          }
          return schema;
        },
      ),
      subject: Yup.string().when(
        'name_of_the_degree',
        (name_of_the_degree, schema) => {
          if (name_of_the_degree === 'FCPS' ||
            name_of_the_degree === 'FCPS-Part-1' ||
            name_of_the_degree === 'MD' ||
            name_of_the_degree === 'MS' ||
            name_of_the_degree === 'MRCP' ||
            name_of_the_degree === 'MRCS' ||
            name_of_the_degree === 'MRCOG' ||
            name_of_the_degree === 'MRCPH') {
            return schema.required('Subject is Required!');
          }
          return schema;
        },
      ),
      present_designation: Yup.string().when(
        'name_of_the_degree',
        (name_of_the_degree, schema) => {
          if (name_of_the_degree === 'FCPS' ||
            name_of_the_degree === 'MD' ||
            name_of_the_degree === 'MS' ||
            name_of_the_degree === 'MRCP' ||
            name_of_the_degree === 'MRCS' ||
            name_of_the_degree === 'MRCOG' ||
            name_of_the_degree === 'MRCPH') {
            return schema.required('Present Designation is Required!');
          }
          return schema;
        },
      ),
      present_working_place: Yup.string().when(
        'name_of_the_degree',
        (name_of_the_degree, schema) => {
          if (name_of_the_degree === 'FCPS' ||
            name_of_the_degree === 'MD' ||
            name_of_the_degree === 'MS' ||
            name_of_the_degree === 'MRCP' ||
            name_of_the_degree === 'MRCS' ||
            name_of_the_degree === 'MRCOG' ||
            name_of_the_degree === 'MRCPH') {
            return schema.required('Present Working Place is Required!');
          }
          return schema;
        },
      ),
      // start_date: Yup.date().max(new Date(Date.now()), 'From date can\'t be a future date').when(
      //   'name_of_the_degree',
      //   (name_of_the_degree, schema) => {
      //     if (name_of_the_degree === 'FCPS-Part-1') {
      //       return schema.required('Strat Date is Required!');
      //     }
      //     return schema;
      //   }),
      // end_date: Yup.date().when("start_date", (start_date, schema) => {
      //   if (start_date) {
      //     const fromDate = new Date(start_date);

      //     return schema.required('End date is Required').min(fromDate, 'To date must be greater than start date').nullable();
      //   }

      //   return schema;
      // }),
      certificate_pdf: Yup.mixed()
        .test('is-pdf', 'Must be a File', (value) => {
          if (value) {
            return [
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/jpg',
            ].includes(value.type);
          }
          return true;
        })
        .test('file-size', 'File too large', (value) => {
          if (value) {
            return value.size <= FILE_SIZE;
          }
          return true;
        }),
    }),
    onSubmit: (values: any) => {
      // if(values.start_date && values.end_date){
      //   values.start_date = moment(
      //     values.start_date,
      //   ).format('YYYY-MM-DD');
      //   values.end_date = moment(
      //     values.end_date,
      //   ).format('YYYY-MM-DD');
      // }
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });
      updateEducationalProfile({ data: formData, id: values.id });

      // const url = putUrlString(values.id, values);

      // updateEducationalProfile(url);
    },
  });

  useEffect(() => {
    const editEduInfo =
      educationalProfile?.data?.details?.educational_infos?.find(
        (info) => info.id! === editInfoID,
      ) ?? ([] as EducationalProfile);
    setPhoto(`${config?.APP_URL}${editEduInfo?.certificate_pdf}`);
    if (editEduInfo) {
      setValues({
        id: editEduInfo.id,
        // name_of_the_degree: editEduInfo.name_of_the_degree || '',
        name_of_the_degree: degreeList?.every(
          (degreeItem: any) =>
            degreeItem?.name !== editEduInfo?.name_of_the_degree,
        )
          ? 'Others'
          : editEduInfo?.name_of_the_degree || '',
        others_name_of_the_degree_value: editEduInfo.name_of_the_degree || '',
        // institute_or_university: editEduInfo.institute_or_university || '',
        institute_or_university: editEduInfo.institute_or_university || '',
        others_institute_or_university_value:
          editEduInfo.institute_or_university || '',
        passing_year: editEduInfo.passing_year || '',
        // start_date: editEduInfo.start_date || '',
        // end_date: editEduInfo.end_date || '',
        subject: editEduInfo.subject || '',
        certificate_pdf: '',
        roll: editEduInfo.roll || '',
        session: editEduInfo.session || '',
        present_designation: editEduInfo.present_designation || '',
        present_working_place: editEduInfo.present_working_place || '',
      });

      setSelectedYear({
        value: editEduInfo.passing_year,
        label: editEduInfo.passing_year,
      })
    }

    if (editEduInfo.others_institute_or_university_value) {
      instituteOptions.push({
        label: editEduInfo.others_institute_or_university_value,
        value: editEduInfo.others_institute_or_university_value,
      });
    }
  }, [educationalProfile, editInfoID]);

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Educational Information Updated Successfully!');
      setIsAddForm(true);
    }
    if (isError) {
      toast.error(err?.message || 'Something Went Wrong!');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);


  useEffect(() => {
    if (selectedYear !== '') {
      setFieldValue('passing_year', selectedYear?.value);
    }
  }, [selectedYear]);

  return (
    <div>
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <Form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="incremental-from-field-grid mb-4">
          <div className="large-from-grid">
            <div>
              <Label for="name_of_the_degree" className="required-field">
                Degree
              </Label>
              <Input
                type="select"
                name="name_of_the_degree"
                value={values.name_of_the_degree}
                onChange={handleChange}
              >
                <option value="">Select Degree</option>
                {degreeList?.map((degreeItem) => (
                  <option key={degreeItem.id} value={degreeItem.name}>
                    {degreeItem.name}
                  </option>
                ))}
                <option value="Others">Others</option>
              </Input>
              {errors.name_of_the_degree && touched.name_of_the_degree ? (
                <div className="text-danger error-size">{errors.name_of_the_degree as string}</div>
              ) : null}
            </div>

            {values.name_of_the_degree === 'Others' ? (
              <div>
                <Label className="form-label required-field">
                  Other Degree
                </Label>
                <InputField
                  type="text"
                  placeholder="Other Degree"
                  invalid={{ errors, touched }}
                  {...getFieldProps('others_name_of_the_degree_value')}
                />
              </div>
            ) : null}

            {/* <div>
              <Label for="institute_or_university" className='required-field'>Institute</Label>
              <Input
                type="select"
                name="institute_or_university"
                value={values.institute_or_university}
                onChange={handleChange}
              >
                <option value="">Select Institute</option>
                {instituteList?.map((instituteItem) => (
                  <option key={instituteItem.id} value={instituteItem.organization_name}>
                    {instituteItem.organization_name}
                  </option>
                ))}
                <option value="Others">Others</option>
              </Input>
              {errors.institute_or_university &&
              touched.institute_or_university ? (
                <div className="text-danger">
                  {errors.institute_or_university}
                </div>
              ) : null}
            </div> */}

            <div>
              <Label for="institute_or_university" className="required-field">
                Institute
              </Label>
              <CreatableSelect
                ref={instituteSearchableRef}
                isSearchable={true}
                options={instituteOptions}
                isClearable={true}
                name="institute_or_university"
                value={instituteOptions.find(
                  (option: SelectOption) =>
                    option.value === values.institute_or_university,
                )}
                onChange={(data: any) => {
                  if (data?.value) {
                    let selectedId = data.value;
                    if (
                      instituteOptions.find(
                        (option: SelectOption) =>
                          option.value === selectedId,
                      )
                    ) {
                      setFieldValue('institute_or_university', selectedId);
                    } else {
                      setFieldValue('institute_or_university', 'Others');
                      setFieldValue(
                        'others_institute_or_university_value',
                        selectedId,
                      );
                    }
                  } else {
                    setFieldValue('institute_or_university', '');
                  }
                }}
              />
              {errors.institute_or_university &&
                touched.institute_or_university ? (
                <div className="text-danger error-size">
                  {errors.institute_or_university as string}
                </div>
              ) : null}
            </div>

            {/* {values.institute_or_university === 'Others' ? (
              <div>
                <Label className="form-label required-field">
                  Other Institute
                </Label>
                <InputField
                  type="text"
                  placeholder="Other Institute"
                  invalid={{ errors, touched }}
                  {...getFieldProps('others_institute_or_university_value')}
                />
              </div>
            ) : null} */}

            {values.name_of_the_degree === 'FCPS' ||
              values.name_of_the_degree === 'FCPS-Part-1' ||
              values.name_of_the_degree === 'MD' ||
              values.name_of_the_degree === 'MS' ||
              values.name_of_the_degree === 'MRCP' ||
              values.name_of_the_degree === 'MRCS' ||
              values.name_of_the_degree === 'MRCOG' ||
              values.name_of_the_degree === 'MRCPH' ? (
              <div>
                <Label>Subject</Label>
                {/* <Input
                  type="select"
                  name="subject"
                  value={values.subject}
                  onChange={handleChange}
                >
                  <option>Select Subject</option>
                  {subjectList?.map((subjectItem) => (
                    <option
                      key={subjectItem.id}
                      value={subjectItem.subject_name}
                    >
                      {subjectItem.subject_name}
                    </option>
                  ))}
                </Input> */}
                <Select
                  isClearable={true}
                  isSearchable={true}
                  value={allSubjects.find(
                    (option: any) =>
                      option.value === values.subject,
                  )}
                  onChange={(e: any) => {
                    if (e?.value) {
                      let selectedId = e.value;
                      setFieldValue('subject', selectedId);
                    } else {
                      setFieldValue('subject', '');
                    }
                  }}
                  options={allSubjects}
                  placeholder='Select Subject'
                  name="subject"
                />
                {errors.subject && touched.subject ? (
                  <div className="text-danger error-size">{errors.subject as string}</div>
                ) : null}
              </div>
            ) : null}

            {values.name_of_the_degree === 'FCPS-Part-1' ? (
              <div>
                <Label className="form-label">Roll</Label>
                <InputField
                  type="text"
                  placeholder="Roll Number"
                  invalid={{ errors, touched }}
                  {...getFieldProps('roll')}
                />
              </div>
            ) : null}

            {values.name_of_the_degree === 'FCPS-Part-1' ? (
              <div>
                <Label for="session">Session</Label>
                <Input
                  type="select"
                  name="session"
                  value={values.session}
                  onChange={handleChange}
                >
                  <option>Select Session</option>
                  {sessionList?.map((sessionItem) => (
                    <option key={sessionItem.id} value={sessionItem.name}>
                      {sessionItem.name}
                    </option>
                  ))}
                </Input>
                {errors.session && touched.session ? (
                  <div className="text-danger error-size">{errors.session as string}</div>
                ) : null}
              </div>
            ) : null}

            <div>
              <Label className="form-label required-field">Passing Year</Label>
              <Select
                isClearable={true}
                isSearchable={true}
                value={selectedYear}
                onChange={setSelectedYear}
                options={allYears}
                placeholder='Select Year'
                name="passing_year"
              />
              {errors.passing_year ? (
                <div className="text-danger error-size">{errors.passing_year as string}</div>
              ) : null}
            </div>
            {/* {values.name_of_the_degree === 'FCPS-Part-1' ? (
              <div>
              <div className="input-group-with-label">
                <div>
                  <Label className="form-Label required-field">Start Date</Label>
                  <Input
                    className="form-control"
                    type="date"
                    name="start_date"
                    onChange={handleChange}
                    value={values.start_date}
                  />
                  {errors.start_date && touched.start_date ? (
                  <div className="text-danger">
                    {errors.start_date as string}
                  </div>
                ) : null}
                </div>
                <div>
                  <Label className="form-Label required-field">End Date</Label>
                  <Input
                    className="form-control"
                    type="date"
                    name="end_date"
                    onChange={handleChange}
                    value={values.end_date}
                  />
                  {errors.end_date && touched.end_date ? (
                  <div className="text-danger">
                    {errors.end_date as string}
                  </div>
                  ) : null}
                </div>
              </div>
            </div>
            ) : null} */}

            {values.name_of_the_degree === 'FCPS' ||
              values.name_of_the_degree === 'MD' ||
              values.name_of_the_degree === 'MS' ||
              values.name_of_the_degree === 'MRCP' ||
              values.name_of_the_degree === 'MRCS' ||
              values.name_of_the_degree === 'MRCOG' ||
              values.name_of_the_degree === 'MRCPH' ? (
              <div>
                <Label className="form-label">Present Designation</Label>
                <Input
                  type="select"
                  name="present_designation"
                  value={values.present_designation}
                  onChange={handleChange}
                >
                  <option>Select Designation</option>
                  {designationList?.map((designationItem) => (
                    <option
                      key={designationItem.id}
                      value={designationItem.name}
                    >
                      {designationItem.name}
                    </option>
                  ))}
                </Input>
                {errors.present_designation && touched.present_designation ? (
                  <div className="text-danger error-size">
                    {errors.present_designation as string}
                  </div>
                ) : null}
              </div>
            ) : null}
            {values.name_of_the_degree === 'FCPS' ||
              values.name_of_the_degree === 'MD' ||
              values.name_of_the_degree === 'MS' ||
              values.name_of_the_degree === 'MRCP' ||
              values.name_of_the_degree === 'MRCS' ||
              values.name_of_the_degree === 'MRCOG' ||
              values.name_of_the_degree === 'MRCPH' ? (
              <div>
                <Label className="form-label">Present Working Place</Label>
                <InputField
                  name="present_working_place"
                  type="text"
                  placeholder="Present Working Place"
                  onChange={handleChange}
                  value={values.present_working_place}
                  invalid={{ errors, touched }}
                />
              </div>
            ) : null}

            <div>
              <Label className="form-label required-field">Certificate</Label>{' '}
              <i
                className="fas fa-info-circle"
                title="Upload certificate as per selected Degree. Format must be .pdf or .jpg or .png. Size cannot be greater than 1MB"
              ></i>
              <a
                className="me-2 p-0 center"
                href={photo}
                rel="noreferrer"
                target="_blank"
              >
                <span className="btn-outline-info btn-sm btn ms-2">View</span>
              </a>
              <input
                ref={fileInputRef}
                name="certificate_pdf"
                type="file"
                className="form-control"
                placeholder="Upload Certificate"
                onChange={(e: any) => {
                  setFieldValue('certificate_pdf', e.target.files[0]);
                }}
              ></input>
              {errors.certificate_pdf && touched.certificate_pdf ? (
                <div className="text-danger error-size">{errors.certificate_pdf as string}</div>
              ) : null}
            </div>
          </div>
          <div className="d-flex mt-3 gap-2">
            <button
              className="btn btn-primary px-5"
              type="submit"
              onClick={(e) => handleSubmit}
            >
              {'Update'}
            </button>
            <button
              className="btn btn-outline-secondary px-5"
              type="button"
              onClick={(e) => {
                resetForm();
                setSelectedYear('');
                setIsAddForm(true);
                fileInputRef.current.value = '';
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default EditEducation;
